/******************************************************************************************
 *	Purchase Authorization Line Item Modal
 ******************************************************************************************/
(function () {
  angular
    .module('rcControllers.productsWithSamePurchaseAuthModal', [])
    .factory(
      'ProductsWithSamePurchaseAuthModal',
      /* @ngInject */
      function (modal) {
        return modal({
          templateUrl: 'views/partials/modals/product-with-same-purchase-auth-modal.html',
          controller: 'ProductsWithSamePurchaseAuthModalController',
          classNames: 'product-with-same-purchase-auth-modal'
        });
      }
    )
    .controller(
      'ProductsWithSamePurchaseAuthModalController',
      /* @ngInject */
      function ($scope, ProductsWithSamePurchaseAuthModal) {
        
        //Close modal
        $scope.removeModal = function () {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          ProductsWithSamePurchaseAuthModal.remove({cancelled: true});
        };
      }
    );
})();
